import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import {Field1Type} from "../../../fields/@const"
import {FieldType} from "../../../fields3/field-type"
import {FieldGroup} from "../../../fields/@group"
import { TasksViewColumnType } from "../../../model2/column/@const"
import FieldProto from "../../../fields3/proto/field-proto";

export function generateColumnIdForCustomField(id: ID): CFString {
    return `CF-${id}` as CFString
}

export type CFString = `CF-${string}`

export type ColumnID = SystemColumnType | CFString

export enum SystemColumnType {

    // System - not really fields
    ADD_CELL                        = '0',
    BULK_ACTION_CHECKBOX            = '1',

    // Universal TASKS + PROJECT
    TITLE                           = '2',
    PRIORITY                        = '3',
    SCHEDULE                        = '4',
    USERS                           = '5',
    STATUS                          = '6',
    TASK_ID                         = '7',
    TASK_TYPE                       = '8',
    DEADLINE                        = '9',
    ESTIMATE                        = '10',
    CREATED_BY                      = '11',
    ACTION_REQUIRED                 = '12',
    START_DATE                      = '13',
    END_DATE                        = '14',
    DATE_CREATED                    = '16',
    TAGS                            = '17',
    ASSIGNED_TO                     = '18',
    TIME_REPORTED                   = '19',
    LAST_UPDATED                    = '20',
    PROGRESS_BAR                    = '21',
    COMMENTS                        = '22',
    OPEN_ALL                        = '23',
    PROJECT_HEALTH                  = '24',
    OWNER                           = '25',

    START_END_DATE                  = '27',
    PROJECT_MANAGER                 = '28',
    PROJECT                         = '29',
    SUBTASKS_COUNTER                = '30',
    DURATION_CALENDAR_DAYS          = '31',
    SPENT_ESTIMATE                  = '32',
    PROGRESS_ITEMS                  = '33',
    DEPENDS_ON                      = '34',
    DEPENDANTS                      = '35',
    DURATION_WORK_DAYS              = '36',
    PROGRESS_TASKS                  = '37',
    COST_INTERNAL                   = '38',
    COST_EXTERNAL                   = '39',
    COST_EXPENSES                   = '40',
    DATE_CLOSED                     = '41',
    STORY_POINTS                    = '42',
    MESSAGES_TOTAL                  = '43',
    ATTACHMENTS_TOTAL               = '44',
    CRM_CONTACT                     = '45',
    CRM_ACCOUNT                     = '46',
    CRM_CONTACTS                    = '47',
    TODO_LIST                       = '48',
    BASELINE                        = '49',
    COVER                           = '50',
    LOCATION                        = '51',
    DESCRIPTION                     = '52',
    PARENT_TASK_ID                  = '53',
    TIME_REPORTED_MINUTES           = '54',
    TIME_REPORTED_HOURS             = '55',
    CUSTOM_FIELD                    = '56',
    PROJECT_FULL_NAME               = '57',
    PROJECT_STATUS_COMMENTS         = '58',
    ESTIMATE_MINUTES                = '59',
    ESTIMATE_HOURS                  = '60',

    ESTIMATED_COST_INTERNAL         = 'estimated-cost-internal',
    ESTIMATED_COST_EXTERNAL         = 'estimated-cost-external',
    ITEM_MODEL_CALCULATED_EXPENSES  = 'item-model-calculated-expenses',
    TASK_LEAD_TIME                  = 'task-lead-time',
    TASK_AGE                        = 'task-age',

    REPORTED_BY                     = 'reported-by',
    REPORT_DATE                     = 'report-date',
    REPORT_IS_BILLABLE              = 'report-is-billable',
    REPORT_MESSAGE                  = 'report-message',
    REPORT_WORK_ITEM                = 'report-work-item',
    REPORT_ID                       = 'report-id',

    // TASKS ONLY

    // PROJECTS ONLY
    PROJECT_COLOR                   = '26',

    PROJECT_ESTIMATE                = 'project-estimate',
    PROJECT_ESTIMATE_TASKS          = 'project-estimate-tasks',
    PROJECT_PATH                    = 'project-path',

    // EVENTS ONLY

    // TIME REPORTS
    START_END_MOMENT                = 'start-end-moment',
    IS_BILLABLE                     = 'time-report-is-billable',
}

// config for column fields classes (TasksView_ColumnSystemField and TasksView_ColumnCustomField)
export type ColumnFieldConfig = ColumnSettingsConfig & {
    type?           : TasksViewColumnType
    customFieldId?  : ID
    label?          : string
    defaultWidth?   : number
}

// This is what we save in settings
export type ColumnSettingsConfig = {
    id                  : ColumnID
    aggregateFunction?  : AggregateFunctionType
    width?              : number
}

// Used for both legacy columns and TasksView_Column.
// TODO: Remove deprecated properties once the Column type (see below) is fully phased out.
export type ColumnConfig = {

    id                      : ColumnID | any // ColumnID - only this one in future

    // start legacy
    lsId?                   : any
    mandatory?              : any // to be removed >?
    // end

    fieldId?                : any

    type                    : TasksViewColumnType
    customFieldId?          : ID // probably all should be set in fieldId but left for now

    title?                  : string // NOT IN USE ???????
    label?                  : string // ??
    icon?                   : string // icon i.e. in add column
    description?            : string // Column description

    group?                  : FieldGroup | string // used to categorize in add column or preferences ?

    aggregateFunction?      : AggregateFunctionType // default aggregate function

    width?                  : number // custom width ?
    defaultWidth?           : number
}

// Deprecated: No longer used in new TaskViews_Columns. Scheduled for removal.
// BAD NAME -  Column is more like a class
// This is what inside of the columsn manager...
export type Column = {

    lsId                : string | number
    id                  : Field1Type | FieldType // | number // whay is that ?:L) Field ID i think ...
    fieldId?            : fieldId // field3 fieldId
    customFieldId?      : ID

    title?              : string
    label?              : string
    icon?               : string
    description?        : string

    width?              : number
    isHidden?           : boolean
    mandatory?          : boolean

    aggregateFunction?  : func
    group?              : string

}




// Experimental
// [
//     {
//         id: FieldGroup,
//         label: 'General',
//         columns: [
//
//         ]
//
//     }
//
// ]

// export type ColumnsConfigV2 = {
//
//
//
//
// }
//
// export type ColumnConfigV2 = {
//
//     id                      : ColumnID | any // ColumnID - only this one in future
//     type                    : TasksViewColumnType
//
//     mandatory?              : any // to be removed >??? do we need it ? title only
//
//     customFieldId?          : ID // probably all should be set in fieldId but left for now
//     field?                  : FieldProto // used in custom fields
//
//
//     label?                  : string // ??
//     icon?                   : string // icon i.e. in add column
//     description?            : string // Column description
//
//     // group?                  : FieldGroup | string // used to categorize in add column or preferences ?
//
//     aggregateFunction?      : AggregateFunctionType // default aggregate function
//
//     width?                  : number // custom width ?
// }




